import {
  ClipboardList,
  Gavel,
  TabletSmartphone,
  LayoutDashboard,
  Layers,
  ListOrdered,
  LogOut,
  Music,
  Settings,
} from "lucide-react";
import {
  Sidebar as LibSidebar,
  type SidebarNavGroup,
} from "@marekl/adminer/shell";
import type { User } from "../../auth/queries";
import type { Competition } from "../../lib/queries/competitions";
import { BrandLockup } from "../../components/BrandLockup";
import { SupportContacts } from "../../components/SupportContacts";
import { CompetitionContextStrip } from "./CompetitionContextStrip";
import type { ID } from "../../lib/id";

interface CompetitionSidebarProps {
  competitionId: ID;
  competition?: Competition;
  user: User;
  onLogout: () => void;
}

// The competition-mode navigation. The competition itself is named in the
// context strip above the nav — not as a nav group label, which is 10px
// dim small caps and turns a real competition name into two unreadable
// lines. Later modules (Hodnocení, Výsledky) append their items to
// „Správa soutěže".
export function CompetitionSidebar({
  competitionId,
  competition,
  user,
  onLogout,
}: CompetitionSidebarProps) {
  const base = `/soutez/${competitionId}`;
  const groups: SidebarNavGroup[] = [
    {
      label: "Správa soutěže",
      items: [
        {
          to: base,
          label: "Přehled",
          end: true,
          icon: <LayoutDashboard aria-hidden="true" />,
        },
        {
          to: `${base}/prihlasky`,
          label: "Přihlášky",
          icon: <ClipboardList aria-hidden="true" />,
        },
        {
          to: `${base}/kategorie`,
          label: "Soutěžní kategorie",
          icon: <Layers aria-hidden="true" />,
        },
        {
          to: `${base}/startovni-listina`,
          label: "Startovní listina",
          icon: <ListOrdered aria-hidden="true" />,
        },
        {
          to: `${base}/hudba`,
          label: "Hudba",
          icon: <Music aria-hidden="true" />,
        },
        {
          to: `${base}/poroty`,
          label: "Poroty",
          icon: <Gavel aria-hidden="true" />,
        },
        {
          to: `${base}/zarizeni`,
          label: "Zařízení",
          icon: <TabletSmartphone aria-hidden="true" />,
        },
        {
          to: `${base}/nastaveni`,
          label: "Nastavení",
          icon: <Settings aria-hidden="true" />,
        },
      ],
    },
  ];

  return (
    <LibSidebar
      groups={groups}
      user={{
        displayName: user.display_name || user.email,
        roleLabel: user.email,
      }}
      profileHref="/profile"
      onLogout={onLogout}
      logoutIcon={<LogOut aria-hidden="true" />}
      footer={<SupportContacts tone="sidebar" />}
      brand={
        <>
          <BrandLockup compact />
          <CompetitionContextStrip competition={competition} />
        </>
      }
    />
  );
}
